
  <h4 class="question" *ngIf="questionGroupQuestion && questionGroupQuestion.question">
    <span class="question__number">{{questionGroupAndQuestionIndex()}}</span>
    <span class="question__formatted" [innerHTML]="getFormattedQuestion(questionGroupQuestion.question)"></span>
    <div *ngIf="questionGroupQuestion.question.isRequired" class="question__required" matTooltip="Required field"
         matTooltipPosition='right'>*</div>

    <div *ngIf="helpTextExist(questionGroupQuestion.question)" class="question__help"
         [matTooltip]="questionGroupQuestion.question.helpText" matTooltipPosition='right'>
      <mat-icon>help</mat-icon>
    </div>
  </h4>

  <div class="answer" *ngIf="questionGroupQuestion && questionGroupQuestion.question">
    <div *ngFor="let option of questionGroupQuestion.question.options">
      <app-question-option [isReadOnly]="isReadOnly" [option]="option"
                           [isRequired]="questionGroupQuestion && questionGroupQuestion.question && questionGroupQuestion.question.isRequired"
                           (questionAnsweredEvent)="questionAnswered()"></app-question-option>
    </div>
  </div>

